import { Tabs, PasswordIcon, ProfileIcon } from '@medeloop/medeloop-components-library';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectAccount } from 'src/store/selectors';

import { Outlet, useLocation, useNavigate } from 'react-router-dom';

export const ProfilePage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const account = useSelector(selectAccount);
  const isSSO = account.isSSO;

  return (
    <div className="flex flex-col flex-grow bg-gray-950 px-10 py-8">
      <span className="text-2xl text-white font-semibold pb-4">{t('my_profile')}</span>
      <Tabs
        value={location.pathname.split('/')[2]}
        onValueChange={(value) => navigate(`/profile/${value}`)}
      >
        <Tabs.List>
          <Tabs.Trigger value="information">
            <ProfileIcon className="w-4 h-4 mr-2" />
            {t('profile_info')}
          </Tabs.Trigger>
          {!isSSO && (
            <Tabs.Trigger value="change-password">
              <PasswordIcon className="w-4 h-4 mr-2" />
              {t('change_password')}
            </Tabs.Trigger>
          )}
        </Tabs.List>
        <Tabs.Content value="information">
          <Outlet />
        </Tabs.Content>
        {!isSSO && (
          <Tabs.Content value="change-password">
            <Outlet />
          </Tabs.Content>
        )}
      </Tabs>
    </div>
  );
};
